import { $, $$ } from 'utils/dom';

class LinkCarousel {
  constructor(props) {
    this.container = props.container;
    this.navItems = $$('.link-carousel__nav-item', this.container);
    this.navItemsAndImages = [
      ...$$('.link-carousel__image', this.container),
      ...$$('.link-carousel__nav-item', this.container),
    ];
    this.arrowButtons = $$('.link-carousel__arrow-button', this.container);
    this.textButtons = $$('.link-carousel__button, this.container');
    this.activeItem = null;
    this.activeClass = 'is-active';
    this.activeSiblingClass = 'is-active-sibling';
  }

  setItemActive = (id, focus = true) => {
    this.navItemsAndImages.forEach(item => {
      const itemId = parseInt(item.getAttribute('data-carousel-item'));
      const isNavItem = item.classList.contains('link-carousel__nav-item');

      /*
      if there is a match:
      - set active- and sibling-classes on nav-items and background-images
      - update this.activeItem
      - focus active item link
       */
      if (itemId === id) {
        item.classList.add(this.activeClass);
        this.activeItem = itemId;
        if (isNavItem) {
          this.setSiblingClass(item);
          if (focus) $('a', item).focus();
        }
      } else {
        item.classList.remove(this.activeClass);
      }
    });
  };

  setSiblingClass = activeItem => {
    const prevItem = activeItem.previousElementSibling;
    const nextItem = activeItem.nextElementSibling;

    this.navItems.forEach(item => {
      if (item.classList.contains(this.activeSiblingClass))
        item.classList.remove(this.activeSiblingClass);
    });

    if (prevItem) prevItem.classList.add(this.activeSiblingClass);
    if (nextItem) nextItem.classList.add(this.activeSiblingClass);
  };

  handleArrowButtonClick = button => {
    const isPrevButton = button.classList.contains('is-prev');
    let nextItemActive;

    // Determine whether to jump to the previous or the next item in the nav-list. If there is no previous or next item in the source code order, let the focus rotate: e.g. when the first item is currently active, the next item to jump to is the last one in the list.
    if (isPrevButton) {
      nextItemActive =
        this.activeItem - 1 < 0
          ? this.navItems.length - 1
          : this.activeItem - 1;
    } else {
      nextItemActive =
        this.activeItem + 1 > this.navItems.length - 1
          ? 0
          : this.activeItem + 1;
    }

    this.setItemActive(nextItemActive);
  };

  handleTextButtonClick = button => {
    const parent = button.parentElement;
    const id = parseInt(parent.getAttribute('data-carousel-item'));
    this.setItemActive(id);
  };

  bindEvents = () => {
    this.arrowButtons.forEach(button => {
      button.addEventListener(
        'click',
        this.handleArrowButtonClick.bind(this, button)
      );
    });
    this.textButtons.forEach(button => {
      button.addEventListener(
        'click',
        this.handleTextButtonClick.bind(this, button)
      );
    });
  };

  setRandomItemActive = () => {
    const randomItem = Math.floor(Math.random() * this.navItems.length);
    this.setItemActive(randomItem, false);
  };

  init = () => {
    this.setRandomItemActive();
    this.bindEvents();
  };
}

const linkCarousels = $$('.link-carousel');
linkCarousels.length &&
  linkCarousels.forEach(carousel => {
    new LinkCarousel({
      container: carousel,
    }).init();
  });
